import React, { Component, PropTypes } from 'react';
import InputControl from 'components/InputControl';
import Tip from 'components/TipControl';
import { ParameterType } from 'types';
import { translate as t } from 'lang';
import './DesiredBudgetPane.scss';

class DesiredBudgetPane extends Component {

    static propTypes = {
        parameter: PropTypes.objectOf(ParameterType).isRequired,
        isIsraelModeOn: PropTypes.bool,
    }

    state = {}

    constructor(props) {
        super(props);
        this.state.value = this.props.parameter.value || '';
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.onChange && nextProps.parameter.value == '') {
            this.props.onChange(undefined);
        }
    }

    _onChangeDesiredBudget = (event, value) => {
        const pattern = /^\d+$/;

        if ((pattern.test(value) && value > 0) || !value) {
            this.setState({
                value: value
            }, () => {
                if (this.props.onChange) {
                    this.props.onChange(value);
                }
            });
        }
    }

    render() {

        const error = t(this.props.parameter.error)

        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }} className="DesiredBudgetPane">
                <span className="DesiredBudgetPane-label">{this.props.parameter.title}</span>
                <InputControl
                    className="DesiredBudgetPane-input"
                    placeholder={this.props.isIsraelModeOn ? 'шек.' : 'руб.'}
                    label=""
                    type="text"
                    pattern="[0-9]*"
                    value={this.state.value}
                    error={error}
                    onChange={this._onChangeDesiredBudget}/>
                <Tip label={this.props.parameter.tip} />
            </div>
        );
    }

}

export default DesiredBudgetPane;



// WEBPACK FOOTER //
// ./client/components/ParametersScreen/DesiredBudgetPane/DesiredBudgetPane.js